window.admin = {
    base: {},
    charity: {},
    payout: {},
    customer: {}
}